import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--column-responsive"
export default class extends Controller {

  static targets = ['class', 'column_12', 'column_6', 'column_4']

  connect() {
    this.classTarget.classList.add('row-cols-2');
  }

  responsive(event) {
    event.preventDefault();
    
    const target = event.currentTarget.dataset['cctv-ColumnResponsiveTarget'];
    const navLinks = this.element.querySelectorAll('.nav-link');

    navLinks.forEach(link => link.classList.add('bg-body-secondary'));
    navLinks.forEach(link => link.classList.remove('text-muted'));

    event.currentTarget.classList.remove('bg-body-secondary');
    event.currentTarget.classList.add('text-muted');

    this.classTarget.className = 'row';
    if (target === "column_1") {
      this.classTarget.classList.add('row-cols-1');
    } else if (target === "column_2") {
      this.classTarget.classList.add('row-cols-2');
    } else if (target === "column_3") {
      this.classTarget.classList.add('row-cols-3');
    } else if (target === "column_4") {
      this.classTarget.classList.add('row-cols-4');
    } else if (target === "column_5") {
      this.classTarget.classList.add('row-cols-5');
    } else if (target === "column_6") {
      this.classTarget.classList.add('row-cols-6');
    }
  }

}
